import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
// import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay';
import { LoaderService } from './services/loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})



export class AppComponent implements OnInit {
  title = 'app';
  isLoading = false;
  payload;
  date = null;

  // currentUser = JSON.parse(localStorage.getItem('currentUser'));

  constructor(
    private authService: AuthService,
    private router: Router,
    private loader: LoaderService
  ) {}

  currentUser = JSON.parse(localStorage.getItem('currentUser'));

  ngOnInit() {

    this.loader.loadingChange.subscribe(isLoading => this.isLoading = isLoading);

    this.authService.authChange.subscribe(currentUser => {
      const currUser = localStorage.getItem('currentUser');

      if (JSON.parse(currUser)) {
        this.currentUser = JSON.parse(currUser);
        this.payload = JSON.parse(atob(this.currentUser.token.split('.')[1]));
      }
    });
    if (this.currentUser) {
      this.payload = JSON.parse(atob(this.currentUser.token.split('.')[1]));


    }
  }
  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}
